import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocalStorageService } from '../../../shared/services/local-storage-service';
import { firstValueFrom } from 'rxjs';
import { ExtractService } from '../../../shared/services/extract-service';
import { HttpClientService } from '../../../shared/services/http-client-service';
import { LoaderService } from '../../../shared/services/loader-service';
import { ToastService } from '../../../shared/services/toast-service';
import { ACCESS_TOKEN_KEY, FLUXO_DEFINITIVO } from '../../constants/storage-keys';

@Component({
  imports: [],
  selector: 'app-token-verify',
  styleUrl: './token-verify.scss',
  template: ''
})
export class TokenVerify implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly extractService = inject(ExtractService);
  private readonly httpClientService = inject(HttpClientService);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly loaderService = inject(LoaderService);
  private readonly toastService = inject(ToastService);

  async ngOnInit(): Promise<void> {
    const params: Params = await firstValueFrom(this.route.queryParams);
    const tokenUrl = params['token'] || params['Token'];
    const payload = tokenUrl && this.extractService.getDecodedAccessToken(tokenUrl);

    // O parâmetro chega como texto: só ?fluxoDefinitivo=true liga o fluxo definitivo ('false' também é truthy).
    this.localStorageService.add(FLUXO_DEFINITIVO, params['fluxoDefinitivo'] === 'true' ? 'true' : 'false');

    if (!payload) {
      this.router.navigate(['/token-invalido']);
      return;
    }

    const rota = await this.newToken(tokenUrl);
    this.router.navigate([rota]);
  }

  /**
   * Troca o token recebido na URL por um novo token de acesso na API e o guarda no
   * localStorage para uso nas demais chamadas de API. O token original é mantido em
   * 'bearerToken' pois carrega os dados do participante usados em outras páginas.
   * Retorna a rota para onde seguir: a home com sucesso, o token inválido com aviso de
   * sistema indisponível no 503 e a página indisponível nos demais erros.
   */
  private async newToken(tokenUrl: string): Promise<string> {
    this.loaderService.showLoader('Carregando...');

    try {
      const { body } = await this.httpClientService.getNovoToken(tokenUrl);

      if (body?.status !== 200 || !body.token) {
        return this.rotaDoErro(body?.status);
      }

      this.localStorageService.add(ACCESS_TOKEN_KEY, `${body.type} ${body.token}`.trim());
      return '/instituto-online/home';
    } catch (erro) {
      console.error('Falha ao obter token de acesso.', erro);
      return this.rotaDoErro(erro instanceof HttpErrorResponse ? erro.status : undefined);
    } finally {
      this.loaderService.hideLoader();
    }
  }

  private rotaDoErro(status: number | undefined): string {
    if (status === 503) {
      this.toastService.show('O sistema está indisponível. Tente novamente.', 'error');
      return '/token-invalido';
    }
    return '/instituto-online/pagina-indisponivel';
  }
}
